import React, { useState } from 'react';
import { useAsyncDebounce } from 'react-table';

import { Input } from '@trqk/components';

interface GlobalFilterInput {
    setGlobalFilter(value: string | undefined): void;
    globalFilter: string;
}

export const GlobalFilter = ({
    globalFilter,
    setGlobalFilter,
}: GlobalFilterInput): JSX.Element => {
    const [inputValue, setInputValue] = useState(globalFilter || '');

    const setGlobalFilterDebounced = useAsyncDebounce((value: string): void => {
        const finalValue = value || undefined; // Set undefined to remove the filter entirely

        setGlobalFilter(finalValue);
    }, 300);

    return (
        <span
            style={{
                alignSelf: 'end',
            }}
        >
            <Input
                addClasses="border border-tertiary-100 text-sm"
                icon="search"
                inputId="works-table-search-input"
                padding="small"
                value={inputValue}
                handleChange={(nextValue: string) => {
                    setGlobalFilterDebounced(nextValue);
                    setInputValue(nextValue);
                }}
                placeholder="Search . . ."
            />
        </span>
    );
};
